module.exports = __webpack_public_path__ + "static/img/icon4.10e45833.png";